import { render } from 'preact';
import { App } from './App';
import { applyBrandToDocument } from './brand/brand';
import './styles/tokens.css';
// Marken-Ueberlagerung (J.1): muss nach tokens.css kommen, siehe brands.css.
import './brand/brands.css';
import './styles/reset.css';
import './styles/base.css';
// Icon + Motion System (Handoff aus docs/claude design/). Keyframes,
// Animationsklassen und die --hv-sheen-Variable. Muss vor jeder Nutzung
// von HvacIcons-Komponenten geladen sein.
import './icons/hvac-icons.css';
// MapLibre GL ships its own baseline CSS (controls, popups, canvas). Import
// here (rather than in MapPage) so it lives in the main CSS bundle and the
// map page has no CSS flash on first render.
import 'maplibre-gl/dist/maplibre-gl.css';

// Attribut data-brand, Fenstertitel und Favicon, bevor irgendetwas zeichnet.
applyBrandToDocument();

const mount = document.getElementById('app');
if (!mount) throw new Error('#app mount point missing from index.html');

render(<App />, mount);
